import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import router from './router'

import 'ant-design-vue/dist/antd.css';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../public/style.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
    // Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)


Vue.config.productionTip = false

Vue.use(Antd);




new Vue({
    router,
    render: h => h(App),
}).$mount('#app')